export default "__VITE_ASSET__Cr8tvPw3__"